import PageLayout from 'pages/CreateAssignment/PageLayout';
import PageProvider from 'pages/CreateAssignment/PageProvider';

const CreateAssignmentPage = ({ ...props }) => {
    return (
        <PageProvider {...props}>
            <PageLayout {...props} />
        </PageProvider>
    );
};

export default CreateAssignmentPage;
